export const FB_NAMESPACE = 'socialLoginFacebook';
export const FB_AUTH_STATUS_CONNECTED = 'connected';
export const FB_AUTH_STATUS_NOT_AUTH = 'not_authorized';
export const FB_AUTH_STATUS_NOT_UNKNOWN = 'unknown';
export const ACCESS_TOKEN_PARAM = 'fbAccessToken';
//# sourceMappingURL=constants.js.map